/**
 * Function that does nothing.
 * Useful as default value for callbacks.
 */
export function noop(): void {}
